<div class="c-premiumPass__info">
  <div
    class="e-background"
    theming
    themingGroup="premiumpass"
    themingAsset="info-background"
    [themingOverride]="premiumPassInfoModalData?.data?.assets">
    <slotcom-navigation-button
      type="close"
      topPosition="0"
      rightPosition="0"
      (click)="closeModal()">
    </slotcom-navigation-button>
  </div>
</div>
